export type City = {
	id: number;
	name: string;
	ibgeCode: string;
	provinceInitials: string;
};

const API_KEY = process.env.REACT_APP_API_KEY || '';

const useCities = () => {

	const fetchCities = async (provinceInitials: string) => {
		const storageKey = `cities-${provinceInitials}`;

		const cachedCities = localStorage.getItem(storageKey);

		if (cachedCities && cachedCities !== '[]') {
			return JSON.parse(cachedCities);
		}

		const response = await fetch(
			`${process.env.REACT_APP_GEOLOCATION_API_URL}/cities?province_initial=${provinceInitials}&fields=id,name,ibgeCode`,
			{
				headers: {
					"x-api-key": API_KEY,
				},
			},
		);

		if (!response.ok) throw new Error('Erro ao buscar cidades');

		const data = await response.json();
		const simplifiedData = data.map((city: any) => ({
			id: city.id,
			name: city.name,
			ibgeCode: city.ibgeCode,
			provinceInitials: city.province?.initials || provinceInitials,
		}));

		localStorage.setItem(storageKey, JSON.stringify(simplifiedData));
		return simplifiedData;

	};

	return { fetchCities };
};

export default useCities;